import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const Loader = ({ onDone }) => {
  const [progress, setProgress] = useState(0);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((p) => Math.min(100, p + 4));
    }, 40);

    const dismiss = () => {
      setProgress(100);
      setHidden(true);
      onDone && onDone();
    };

    const finish = setTimeout(dismiss, 1600);

    // Safeguard: if tab was backgrounded (timers throttled) then refocused,
    // and once the window has fully loaded, dismiss promptly.
    const onVisible = () => {
      if (document.visibilityState === "visible") setTimeout(dismiss, 300);
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("load", () => setTimeout(dismiss, 800));

    return () => {
      clearInterval(interval);
      clearTimeout(finish);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [onDone]);

  return (
    <AnimatePresence>
      {!hidden && (
        <motion.div
          data-testid="loader-overlay"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[100] bg-[#050505] flex flex-col items-center justify-center"
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <div className="font-display text-3xl md:text-4xl text-white tracking-tight">
              Alexa<span className="text-gold-gradient"> Financial</span>
            </div>
            <div className="text-[11px] tracking-[0.4em] uppercase text-[#a3a3a3] mt-3">
              Multiservices
            </div>
          </motion.div>
          <div className="mt-10 w-[220px] md:w-[280px] h-px bg-white/10 overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-[#f3e5ab] to-[#d4af37] transition-[width] duration-100 ease-linear"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="mt-4 text-xs text-[#666] tabular-nums">{progress}%</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
